module.exports = __webpack_public_path__ + "img/pcbanner.60532b7c.png";